import React from "react"
import styles from "./listRefreshBar.module.scss"

export const listRefreshStyles = styles

/** Thin sliding bar for background list refreshes. Parent needs `listRefreshStyles.refreshHost` (position: relative). */
const ListRefreshBar: React.FC<{ active: boolean }> = ({ active }) => {

    if (!active) return null

    return (
        <div className={styles.bar} role="progressbar" aria-label="Loading">
            <span className={styles.barFill} />
        </div>
    )
}

export default ListRefreshBar
